import { Users } from 'lucide-react';

export function Characters() {
  return (
    <div className="px-4 py-4 max-w-md mx-auto">
      <h1 className="text-xl font-semibold mb-1">キャラクター</h1>
      <p className="text-xs text-slate-400 mb-4">プリセットとカスタム</p>

      <div className="card text-center py-10">
        <Users className="h-8 w-8 text-slate-600 mx-auto mb-3" />
        <p className="text-slate-400 text-sm">
          VRMカスタマイザーは今後のリリースで有効化
        </p>
        <p className="text-[11px] text-slate-500 mt-2">
          現在はデフォルトキャラを使用
        </p>
      </div>
    </div>
  );
}
